export default __webpack_public_path__ + "static/media/elza-noord.08888add.jpg";